import { useEffect, useRef } from "react";

const SAVE_MS = 8000;

const storageKey = (projectHash) => `changeDraft:${projectHash}`;

export function readChangeDraft(projectHash) {
  if (!projectHash) return "";
  try {
    return localStorage.getItem(storageKey(projectHash)) || "";
  } catch {
    return "";
  }
}

/** Persist draft text; empty/whitespace clears the saved draft. */
export function persistChangeDraft(projectHash, text) {
  if (!projectHash) return;
  try {
    const next = text || "";
    if (!next.trim()) localStorage.removeItem(storageKey(projectHash));
    else localStorage.setItem(storageKey(projectHash), next);
  } catch {
    // ignore quota / private mode
  }
}

export function clearChangeDraft(projectHash) {
  if (!projectHash) return;
  try {
    localStorage.removeItem(storageKey(projectHash));
  } catch {
    // ignore
  }
}

/**
 * Restore saved change text for a project and persist every ~8s while mounted.
 * Call clearChangeDraft(projectHash) after a successful create.
 */
export function useChangeDraft(projectHash, value, setValue) {
  const valueRef = useRef(value);
  valueRef.current = value;
  const restoredFor = useRef(null);

  useEffect(() => {
    if (!projectHash || restoredFor.current === projectHash) return;
    restoredFor.current = projectHash;
    // Always apply (including "") so switching projects does not leave the prior site's text.
    setValue(readChangeDraft(projectHash));
  }, [projectHash, setValue]);

  useEffect(() => {
    if (!projectHash) return undefined;
    const timer = setInterval(() => {
      persistChangeDraft(projectHash, valueRef.current);
    }, SAVE_MS);
    return () => {
      clearInterval(timer);
      persistChangeDraft(projectHash, valueRef.current);
    };
  }, [projectHash]);
}
